import React from "react";
import { SearchBar } from "../SearchBar/SearchBar";
import "./Inicio.css";

export const Inicio = () => {
    
    return(

        <div 
            className="row main-p"
            style={{height: window.innerHeight}}
        >
            <div className="col-md-6 col-sm-10 col-12 left-container">
                <div className="d-block d-sm-none name-container">
                    <h2 className="title">MONO</h2>
                    <p className="subtitle">E-Commerce</p>
                </div>
                <div className="inicio-container">
                    <div className="title-container">
                        <img
                            src="https://valentinnicheglod.github.io/MONO-/no-see-monkey.png"
                            alt="img"
                            width="75"
                            draggable="false"
                        />
                        <img
                            src="https://valentinnicheglod.github.io/MONO-/no-hear-monkey.png"
                            alt="img"
                            width="75"
                            draggable="false"
                        />
                        <img
                            src="https://valentinnicheglod.github.io/MONO-/no-speak-monkey.png"
                            alt="img"
                            width="75"
                            draggable="false"
                        />
                        <div className="d-none d-sm-block">
                            <h2 className="title">MONO</h2>
                            <p className="subtitle">E-Commerce</p>
                        </div>
                    </div>
                    <SearchBar />
                </div>
            </div>
            <div className="d-none d-md-flex justify-content-center col-md-6 monkey-img left-container">
                <img
                    src="https://creazilla-store.fra1.digitaloceanspaces.com/emojis/58433/monkey-emoji-clipart-xl.png"
                    alt="img"
                    id="img"
                    draggable="false"
                />
            </div>
        </div>

    );
};
